import React from 'react';
import * as Formatting from 'fw/misc/Formatting'

class DateTime extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
        return <React.Fragment>{Formatting.formatDateTime(this.props.value)}</React.Fragment>
    }
}

export default DateTime;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/DateTime.js